module.exports = __webpack_public_path__ + "img/title-bg.430de602.png";